import React, { useState, useEffect } from 'react';
import styles from './YourProfile.module.scss';
import { Input, Radio, Button, Modal, App, Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import icon2 from '@/assets/images/路径 1640@2x.png';
import type { UploadProps } from 'antd';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { saveUserInfo, deleteUserAccount } from '@/api/user';
import CookieUtil from '@/utils/cookies';
import { setUserInfo, logout } from '@/store/slices/userSlice';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getTokenValidity } from '@/api/user';
interface IForm {
  name: string;
  label: string;
  avatarUrl: string;
};



const YourProfile: React.FC = () => {
  const [showPublishModal, setShowPublishModal] = useState(false);
  const { message } = App.useApp();
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const userInfo = useAppSelector((state) => state.user.userInfo);
  //获取token
  const token = useAppSelector((state) => state.user.token);

  //表单数据
  const [formData, setFormData] = useState<IForm>({
    avatarUrl: '',
    name: '',
    label: '',
  });



  //图片上传配置
  const ImageProps: UploadProps = {
    name: 'file',
    listType: 'picture-card',
    action: `${process.env.REACT_APP_API_URL}/api/product/save_upload_file`,
    accept: ".png,.jpeg,.jpg,.gif",
    headers: {
      //记得修改
      token: `${token}`,
    },
    maxCount: 1, // 只允许上传一个
    showUploadList: false, // 不显示fileList
    beforeUpload: (file) => {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        message.error("Image must be smaller than 10MB!");
      }
      return isLt10M; // 返回 false 阻止上传
    },
    onChange(info) {

      if (info.file.status === 'done') {
        
        if(info?.file?.response?.data?.url){
          setFormData({
            ...formData,
            avatarUrl: info?.file?.response?.data?.url
          });
        }

      }else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
      

    },
  };




  //提交表单
  const handleOk = () => {
    if (formData.avatarUrl === '') {
      message.error(`${t('YourProfile.Avatar')}`);
      return;
    }

    if (formData.name === '') {
      message.error(`${t('YourProfile.Name')}`);
      return;
    }

    console.log(formData);

    saveUserInfo({
      avatarUrl: formData.avatarUrl,
      label: formData.label,
      name: formData.name
    }).then((res) => {
    
      if(res.code == 200){
        message.success(`${t('YourProfile.Success')}`);
        const userInfo = CookieUtil.get('userInfo');
        if(!!userInfo){
          userInfo.photo = formData.avatarUrl;
          userInfo.nick_name = formData.name;
          userInfo.label = formData.label;
          CookieUtil.set('userInfo', userInfo);
          dispatch(setUserInfo(userInfo));
        }
      }
    });
  };
  const closeDeleteAccountModal = () => {
    setShowPublishModal(false);

  };
  const confirmDeleteAccountModal = () => {
    // 显示加载提示
    const hide = message.loading(t('YourProfile.Deleting') || 'Deleting account...', 0);
    
    deleteUserAccount().then(res =>{
      hide(); // 关闭加载提示
      
      if(res.code == 200){
        setShowPublishModal(false);
        
        // 立即清除所有用户数据
        dispatch(logout());
        
        // 显示成功提示
        message.success(t('YourProfile.Success'));
        localStorage.setItem('locationHref',String(window.location.pathname));
        // 短暂延迟后强制刷新到登录页(确保完全清除状态)
        setTimeout(() => {
          window.location.href = '/Login';
        }, 800);
      }else {
        message.error(res.message);
      }
    }).catch(err => {
      hide(); // 出错时也要关闭加载提示
      message.error(t('common.error') || 'Delete failed');
    })
  }
  //mounted
  useEffect(() => {
    setFormData({
      avatarUrl: userInfo?.photo || '',
      name: userInfo?.nick_name || '',
      label: userInfo?.label || '',
    });
    //查看当前token是否有效
    getTokenValidity().then(res =>{
      if(res.code == 200){
        if(!res.data.is_valid){
          message.error(i18n.t('common.unauthorized'));
          setTimeout(()=>{
             navigate('/Login')
          },500)
        }
      }else {
        message.error(res.message);
      }
    })
  }, []);



  return (
    <div className={styles['profile-box']}>
      <div className={styles['profile-title']}>
        <div className={styles['profile-title-lf']}>{t("YourProfile.YProfile")}</div>
        <div className={styles['profile-title-rg']} onClick={() => setShowPublishModal(true)}>{t("YourProfile.DeleteAccountData")}</div>
         <Modal
          title={t('YourProfile.DeleteAccountDataTitle')}
          open={showPublishModal}
          onCancel={() => setShowPublishModal(false)}
          footer={[
            <Button key="cancel" onClick={closeDeleteAccountModal}>
              {t('common.Cancel')}
            </Button>,
            <Button key="confirm" type="primary" onClick={confirmDeleteAccountModal}>
              {t('common.Confirm')}
            </Button>
          ]}
          width={1200}
          centered
        > 
        <p>{t('YourProfile.DeleteAccountDataInfo')}</p>
        </Modal>
      </div>
      <div className={styles['profile-tip']}>
        {t('YourProfile.Dear')} {(userInfo?.username) }, {t('YourProfile.FillingInformation')}
      </div>

      <div className={styles['profile-form']}>
        <div className={styles['profile-row']}>
          <div className={styles['profile-label']}>{t("YourProfile.CurrentAvatar")}</div>
          <Upload
            className={styles['profile-avatar-upload']}
            {...ImageProps}
          > 
            {
              formData.avatarUrl ? 
              <img className={styles['profile-avatar']} src={formData.avatarUrl} />:
              <PlusOutlined />
            }
            
          </Upload>
        </div>
        <div className={styles['profile-row']}>
          <div className={styles['profile-label']}>{t("YourProfile.DName")}</div>
          <div className={styles['profile-name-box']}>
            <Input
              className={styles['profile-name-input']}
              value={formData.name}
              onChange={e => setFormData({ ...formData, name: e.target.value })}
              placeholder={t('YourProfile.Name')}
            />
            <div className={styles['profile-name-tip']}>
              <img className={styles['profile-name-img']} src={icon2} alt="" />
              <span>1.{t('YourProfile.FillingInformation')}<br />2. {t('YourProfile.TheNameShould')}</span>
            </div>
          </div>
        </div>


        <div className={styles['profile-row']}>
          <div className={styles['profile-label']}>{t("YourProfile.Label")}</div>
          <div className={styles['profile-name-box']}>
            <Input
              className={styles['profile-name-input']}
              value={formData.label}
              onChange={e => setFormData({ ...formData, label: e.target.value })}
              placeholder={t('YourProfile.LabelP1')}
            />
            <div className={styles['profile-name-tip']}>
              <img className={styles['profile-name-img']} src={icon2} alt="" />
              <span>1.{t('YourProfile.PubliclyShown')}<br />2.{t('YourProfile.Profiletext')}</span>
            </div>
          </div>
        </div>
     
        <div className={styles['profile-row']}>
          <Button
            type="primary"
            className={styles['profile-btn']}
            onClick={handleOk}
          >{t("YourProfile.Submit")}</Button>
        </div>
      </div>
    </div>
  );
};

export default YourProfile; 